import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["element"];
  static classes = ["active"];

  call(e) {
    this._activeElement()?.classList?.remove(this.activeClass);
    e.currentTarget.classList.add(this.activeClass);
  }

  _activeElement() {
    return this.elementTargets.find((element) => element.classList.contains(this.activeClass));
  }
}
